import React, { useState } from 'react';
import { WingrMascot } from '../components/WingrMascot';

const MOODS = ['idle', 'listening', 'thinking', 'success', 'greeting'];
const WORD = {
  fontWeight: 800,
  letterSpacing: '0.01em',
  fontFamily: 'Poppins, ui-sans-serif, system-ui, sans-serif',
  color: '#fff',
  lineHeight: 0.85,
};

function LogoPreview({ size, mood }) {
  const word = Math.max(14, Math.round(size * 0.52));
  const arcId = `logo-arc-${size}`;
  return (
    <span style={{ position: 'relative', display: 'inline-flex', alignItems: 'center', gap: Math.round(size * 0.06) }}>
      <svg
        aria-hidden="true"
        viewBox="0 0 1000 200"
        preserveAspectRatio="none"
        style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', overflow: 'visible', pointerEvents: 'none' }}
      >
        <defs>
          <linearGradient id={`${arcId}-top`} x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#5ec8ff" stopOpacity="0" />
            <stop offset="18%" stopColor="#5ec8ff" stopOpacity="1" />
            <stop offset="100%" stopColor="#5ec8ff" stopOpacity="0.15" />
          </linearGradient>
          <linearGradient id={`${arcId}-bot`} x1="0" y1="0" x2="1" y2="0">
            <stop offset="0%" stopColor="#5ec8ff" stopOpacity="0.2" />
            <stop offset="35%" stopColor="#5ec8ff" stopOpacity="1" />
            <stop offset="100%" stopColor="#5ec8ff" stopOpacity="0" />
          </linearGradient>
        </defs>
        <path vectorEffect="non-scaling-stroke" d="M255 58 C 370 8, 520 0, 745 62" fill="none" stroke={`url(#${arcId}-top)`} strokeWidth="1.75" strokeLinecap="round" />
        <path vectorEffect="non-scaling-stroke" d="M600 152 C 760 186, 900 184, 1005 148" fill="none" stroke={`url(#${arcId}-bot)`} strokeWidth="1.65" strokeLinecap="round" />
      </svg>
      <span style={{ ...WORD, fontSize: word, position: 'relative' }}>WINGR</span>
      <WingrMascot size={size} mood={mood} />
      <span style={{ ...WORD, fontSize: word, position: 'relative' }}>BOT</span>
    </span>
  );
}

export default function MascotPreview() {
  const [mood, setMood] = useState('idle');

  React.useEffect(() => {
    const id = 'mascot-preview-font';
    let link = document.getElementById(id);
    if (!link) {
      link = document.createElement('link');
      link.id = id;
      link.rel = 'stylesheet';
      document.head.appendChild(link);
    }
    link.href = 'https://fonts.googleapis.com/css2?family=Poppins:wght@800&display=swap';
    return undefined;
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#070b16', color: '#e2e8f0', padding: '40px 24px 64px', fontFamily: 'ui-sans-serif, system-ui, sans-serif' }}>
      <p style={{ letterSpacing: '.16em', textTransform: 'uppercase', fontSize: 12, color: '#93c5fd', margin: '0 0 8px' }}>Local only</p>
      <h1 style={{ fontSize: 28, fontWeight: 700, margin: '0 0 28px' }}>Mascot check</h1>

      <section style={{ display: 'flex', gap: 48, alignItems: 'center', flexWrap: 'wrap', marginBottom: 48 }}>
        <div>
          <p style={{ margin: '0 0 12px', color: '#94a3b8' }}>Large</p>
          <WingrMascot size={280} mood={mood} />
        </div>
        <div>
          <p style={{ margin: '0 0 12px', color: '#94a3b8' }}>Logo</p>
          <LogoPreview size={72} mood={mood} />
          <div style={{ height: 28 }} />
          <p style={{ margin: '0 0 12px', color: '#94a3b8' }}>Header size</p>
          <div style={{ background: '#0f172a', borderRadius: 12, padding: '14px 18px', display: 'inline-block' }}>
            <LogoPreview size={48} mood={mood} />
          </div>
        </div>
      </section>

      <section style={{ display: 'flex', gap: 40, alignItems: 'flex-end', flexWrap: 'wrap', marginBottom: 36 }}>
        <div>
          <p style={{ margin: '0 0 12px', color: '#94a3b8' }}>Favicon</p>
          <div style={{ background: '#0f172a', borderRadius: 10, padding: '8px 14px', display: 'inline-flex', alignItems: 'center', gap: 8 }}>
            <img src="/wingr-wing-icon.png" alt="" width={16} height={16} />
            <span style={{ fontSize: 13, color: '#e2e8f0' }}>Mascot check</span>
          </div>
        </div>
        <div>
          <p style={{ margin: '0 0 12px', color: '#94a3b8' }}>Taskbar</p>
          <div style={{ width: 64, height: 64, borderRadius: 14, background: '#0f172a', display: 'grid', placeItems: 'center' }}>
            <img src="/wingr-wing-icon.png" alt="" width={52} height={52} />
          </div>
        </div>
      </section>

      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
        {MOODS.map((name) => (
          <button
            key={name}
            type="button"
            onClick={() => setMood(name)}
            style={{
              border: mood === name ? '2px solid #fff' : '2px solid transparent',
              borderRadius: 12,
              padding: '10px 16px',
              fontWeight: 700,
              cursor: 'pointer',
              color: '#fff',
              background: 'linear-gradient(90deg, #3b82f6 0%, #0ea5e9 100%)',
              boxShadow: '0 8px 18px rgba(59, 130, 246, 0.35)',
            }}
          >
            {name}
          </button>
        ))}
      </div>
      <p style={{ marginTop: 18, color: '#94a3b8', maxWidth: 640 }}>
        The site lockup: Poppins, the two blue arcs, and the moving mascot.
      </p>
    </div>
  );
}
